var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 40,
    viewBox: "0 0 38 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9433 0C11.9669 0 6.31445 5.67791 6.31445 12.6544C6.31445 16.6009 8.17314 20.3183 11.3049 22.7116C4.45576 25.7161 0 32.4889 0 40H4.22661C4.22661 31.8778 10.8211 25.2833 18.9433 25.2833C27.0656 25.2833 33.6601 31.8778 33.6601 40H37.8867C37.8867 32.5143 33.4309 25.7161 26.5818 22.7116C32.1324 18.485 33.2272 10.5665 29.0006 5.01591C26.6327 1.85869 22.8899 0 18.9433 0ZM18.9433 4.20115C23.6028 4.20115 27.3711 7.94398 27.3966 12.6034C27.3966 17.2629 23.6537 21.0312 18.9943 21.0567C14.3348 21.0821 10.5411 17.3138 10.5411 12.6544C10.5411 12.6544 10.5411 12.6544 10.5411 12.6289C10.5156 7.99491 14.2584 4.22661 18.8924 4.20115C18.9179 4.20115 18.9179 4.20115 18.9433 4.20115Z",
    fill: "#B30200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorUserIcon);
export default __webpack_public_path__ + "static/media/errorUserIcon.e14dc32b0ac255264e18ceef469b1372.svg";
export { ForwardRef as ReactComponent };